import React from 'react';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Card from '../../common/CardV2/Card';
import s from './TwoColumnsCardWidget.scss';

const TwoColumnsCardWidget = props => {
  const { item, subSecSeoLocation } = props;
  if (!(item && Array.isArray(item.items) && item.items.length)) return null;

  const cardItems = item.items;
  const gaAction = item.gaAction || 'RHS-featured-in-Ent';
  const gaLabel = subSecSeoLocation || '';

  return (
    <InViewObserver
      inViewCallback={() => {
        if (props.isRHSWidgetPS) {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'featured_rhs_widget',
            label: `${item.name || 'Featured Top Stories'}`,
          });
        } else {
          sendGaThroughProps({
            data: {
              gaAction: `view-${gaAction}`,
              gaLabel,
              nonInteraction: true,
            },
          });
        }
      }}
      viewMargin="200px 0px 200px 0px"
    >
      <div className={s.two_col_widget_container}>
        <div className={s.two_col_widget_heading}>
          <h2>{item.name || 'Featured Top Stories'}</h2>
        </div>
        <div className={s.two_col_widget_cards}>
          <div className={s.two_col_widget}>
            {Array.isArray(cardItems) &&
              cardItems.length > 0 &&
              cardItems.map((cardItem, index) => (
                <Card
                  data={cardItem}
                  key={cardItem?.wu}
                  isVerticalTile
                  lazyload
                  onClick={() => {
                    if (props.isRHSWidgetPS) {
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: 'featured_rhs_widget',
                        label: `${item.name || 'Featured Top Stories'}`,
                        category: 'story_click',
                        story_no: `${index + 1}`,
                      });
                    } else {
                      sendGaThroughProps({
                        data: {
                          gaAction: `click-${gaAction}`,
                          gaLabel: `${index}-${cardItem?.wu}`,
                        },
                      });
                    }
                  }}
                />
              ))}
          </div>
        </div>
      </div>
    </InViewObserver>
  );
};

export default TwoColumnsCardWidget;
